import { FileStorageService } from "./file-storage.service";

export class MyUploadAdapter {
  private loader: any;
  private fileStorageService: FileStorageService;

  constructor(
    private loaderI: any,
    private fileStorageServiceI: FileStorageService
  ) {
    this.loader = loaderI;
    this.fileStorageService = fileStorageServiceI;
  }

  async upload() {
    return this.loader.file.then((file: File) => {
      console.log("🚀 ~ MyUploadAdapter ~ upload ~ file:", file);
      var formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", file.name); //file.data.name
      formData.append("folder", "user/uploads");

      return new Promise(async (resolve, reject) => {
        (await this.fileStorageService.uploadImageKit(formData)).subscribe({
          next: (res: any) => {
            console.log("UPLOAD SUCCESS", res);

            resolve({
              default: res,
            });
          },

          error: (err) => {
            console.error(err);

            reject(err);
          },
        });
      });
    });
  }

  abort() {
    console.log("Upload aborted");
  }
}
